export const DEFAULT_SEARCH_DEBOUNCE = 500;
